import { createTheme } from '@mui/material'

const benTheme = createTheme({
  palette: {
    background: {
      default: '#f9fafc',
      input: '#f4f6f9',
      paper: '#ffffff',
    },
    primary: {
      light: '#f6685e',
      main: '#f44336',
      dark: '#aa2e25',
    },
  },
})

export default benTheme
